import { Button, Grid } from '@mui/material';
import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import { handleCloseSuccessfulTrainingDetails } from '../../store/mlcreator-slice/mlcreator';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import React from 'react';
import Transition from '../common/Transition';
import TrainingDetails from './TrainingDetails';

const SuccessfulTrainingDetails = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { successfulTrainReponse, successfulTrainResponseModalOpen } = useAppSelector((state: RootState) => state.mlcreator);

    function handleClose() {
        dispatch(handleCloseSuccessfulTrainingDetails());
    }

    return(
        <React.Fragment>
            <Dialog
                open={successfulTrainResponseModalOpen}
                TransitionComponent={Transition}
                keepMounted
                onClose={(_, reason) => {
                    if(reason !== 'backdropClick') handleClose();
                }}
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth="sm"
            >
                <Grid p={2}>
                    <TrainingDetails trainingDetails={successfulTrainReponse}/>
                </Grid>
                <DialogActions>
                    <Button size="small" variant='contained' className="button-color"  onClick={handleClose}>{t('CLOSE_BUTTON')}</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default SuccessfulTrainingDetails;